import { render, staticRenderFns } from "./CreateSelect.vue?vue&type=template&id=5586a05c&scoped=true"
import script from "./CreateSelect.vue?vue&type=script&lang=ts"
export * from "./CreateSelect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5586a05c",
  null
  
)

export default component.exports